import React, { useCallback, useState } from 'react';
import { AppButton, Box, Heading, PenIcon } from '@common-fe/common-fe';

import { useEditDeductibleModalStore } from '@/modules/deductibles/EditDeductibleModal/stores/useEditDeductibleModal.store.ts';
import { EnrollmentModal } from '@/modules/employee/Employee/EnrollmentModal';
import { PlanTypes } from '@/modules/employee/Employee/EnrollmentModal/enrollmentModal.types';

interface Props {
  healthPlanName?: string;
  healthPlanId?: string;
  healthPlanCoverageLevel?: string;
}

const HealthPlanSpendTrackerDetailsHeader: React.FC<Props> = ({
  healthPlanName,
  healthPlanId,
  healthPlanCoverageLevel,
}) => {
  const [isEditEnrollmentModalVisible, setIsEditEnrollmentModalVisible] = useState(false);
  const setEditDeductibleModalVisible = useEditDeductibleModalStore((state) => state.setState);

  const handleOpenEditEnrollmentModal = useCallback(() => {
    setIsEditEnrollmentModalVisible(true);
  }, []);

  const handleOpenEditDeductibleModal = useCallback(() => {
    setEditDeductibleModalVisible({ visible: true });
  }, [setEditDeductibleModalVisible]);

  return (
    <>
      <Box
        data-testId="health-plan-spend-tracker-details-header"
        direction="row"
        align="center"
        justify="between"
      >
        <Heading level={4} size="large" color="textTitle" margin={{ vertical: 'xxs' }}>
          {healthPlanName}
        </Heading>

        <Box gap="s" direction="row" align="center">
          <AppButton
            testId="edit-enrollment"
            onClick={handleOpenEditEnrollmentModal}
            buttonType="secondary"
            color="grey"
            rightIcon={<PenIcon />}
          >
            Edit Enrollment
          </AppButton>
          <AppButton
            testId="edit-deductible"
            onClick={handleOpenEditDeductibleModal}
            buttonType="secondary"
            color="grey"
            rightIcon={<PenIcon />}
          >
            Edit Deductibles
          </AppButton>
        </Box>
      </Box>
      {isEditEnrollmentModalVisible && (
        <EnrollmentModal
          isVisible={isEditEnrollmentModalVisible}
          onSetVisible={setIsEditEnrollmentModalVisible}
          planType={PlanTypes.HEALTH}
          healthPlanId={healthPlanId}
          coverageLevel={healthPlanCoverageLevel}
          isEdit
          isWithoutButton
        />
      )}
    </>
  );
};

export default HealthPlanSpendTrackerDetailsHeader;
